import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi
} from "@angular/common/http";
import { ErrorHandler, importProvidersFrom, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
    MatDateFormats,
    MAT_DATE_FORMATS,
    NativeDateModule
} from "@angular/material/core";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import {
    NavigationError,
    provideRouter,
    withInMemoryScrolling,
    withNavigationErrorHandler
} from "@angular/router";
import { TINYMCE_SCRIPT_SRC } from "@tinymce/tinymce-angular";
import { AppComponent } from "./app/app.component";
import { APP_ROUTES } from "./app/app.router.module";
import { AccountService } from "./app/services/account.service";
import { AccountingService } from "./app/services/accounting.service";
import {
    AppErrorHandler,
    AppUpdateService,
    isChunkLoadError
} from "./app/services/app-update.service";
import { AppService } from "./app/services/app.service";
import { AuthService } from "./app/services/auth.service";
import { AuthInterceptor } from "./app/services/auth_interceptor.service";
import { ClaimService } from "./app/services/claim.service";
import { DashboadService } from "./app/services/dashboard.service";
import { DocumentLibraryService } from "./app/services/document-library.service";
import { EmailNotificationService } from "./app/services/email-notification.service";
import { FilterService } from "./app/services/filter.service";
import { LoanService } from "./app/services/loan.service";
import { NotificationService } from "./app/services/notification.service";
import { SessionService } from "./app/services/session.service";
import { StatisticsService } from "./app/services/statistics.service";
import { UserSettingService } from "./app/services/user-setting.service";
import { UserService } from "./app/services/user.service";

const ISI_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: null
    },
    display: {
        dateInput: { year: "numeric", month: "2-digit", day: "2-digit" },
        dateA11yLabel: { year: "numeric", month: "long", day: "2-digit" },
        monthYearLabel: { year: "numeric", month: "short" },
        monthYearA11yLabel: { year: "numeric", month: "long" }
    }
};

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule,
            FormsModule,
            MatDialogModule,
            NativeDateModule
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: ISI_DATE_FORMATS
        },
        {
            provide: TINYMCE_SCRIPT_SRC,
            useValue: "/tinymce/tinymce.min.js"
        },
        {
            provide: ErrorHandler,
            useClass: AppErrorHandler
        },
        AccountService,
        AccountingService,
        AppService,
        AuthService,
        ClaimService,
        DashboadService,
        DocumentLibraryService,
        EmailNotificationService,
        FilterService,
        LoanService,
        NotificationService,
        SessionService,
        StatisticsService,
        UserService,
        UserSettingService,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations(),
        provideRouter(
            APP_ROUTES,
            withInMemoryScrolling({
                scrollPositionRestoration: "enabled",
                anchorScrolling: "enabled"
            }),
            withNavigationErrorHandler((e: NavigationError) => {
                if (isChunkLoadError(e.error)) {
                    inject(AppUpdateService).promptReload();
                }
            })
        )
    ]
}).catch((err) => console.log(err));
